import { render, staticRenderFns } from "./MyOrder.vue?vue&type=template&id=367a2aae&scoped=true"
import script from "./MyOrder.vue?vue&type=script&lang=js"
export * from "./MyOrder.vue?vue&type=script&lang=js"
import style0 from "./MyOrder.vue?vue&type=style&index=0&id=367a2aae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367a2aae",
  null
  
)

export default component.exports